import CustomError from './custom-error';
export default CustomError.withDefaultMessage('AssertionError', 'the asserted condition is invalid');
//# sourceMappingURL=assertion-error.js.map